import { useMemo } from 'react';

import eventImage1 from './../assets/images/Events/burrow6.jpeg';
import eventImage2 from './../assets/images/Events/christmasPoster.jpeg';

const events = [
  {
    title: 'The Fox Christmas Parties',
    image: eventImage2,
    description:
      'We know it is early but get your spot secured on one of our incredible Christmas events! We have something for everyone, whether you want to hit the slopes or enjoy a delicious meal.\n\nVisit our Christmas Events page to book your unforgettable experience!',
    reserveLink:
      '/Christmas'
  },
    {
    title: 'BURROW is back',
    image: eventImage1,
    description:
      'Burrow Social Club is Back on Saturday 21st November. 7pm - Late with DJ Steveo Evans on the decks 🎧 \n\nStreet food to be announced.',
    reserveLink:
      'https://www.skiddle.com/whats-on/Dudley/The-Fox-Inn/The-Fox-Inn--Burrow-A-Fox-Social-Club/43155118/'
  }
];

const EventPopupModal = ({ onClose }) => {
  const selectedEvent = useMemo(() => {
    return events[Math.floor(Math.random() * events.length)];
  }, []);

  const handleReserveNow = () => {
    window.open(selectedEvent.reserveLink, '_self');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-2xl shadow-lg relative w-[90vw] h-[90%] overflow-y-scroll max-w-xl p-4 sm:p-6">
        
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-black text-2xl"
          aria-label="Close"
        >
          ×
        </button>

        {/* Event Image */}
        <img
          src={selectedEvent.image}
          alt={selectedEvent.title}
          className="w-full h-auto rounded-2xl mb-4"
          style={{ maxHeight: '60vh', objectFit: 'contain' }}
        />

        {/* Event Content */}
        <h2 className="text-2xl sm:text-3xl font-bold mb-3">
          {selectedEvent.title}
        </h2>

        <p className="text-gray-700 mb-6 text-sm sm:text-base whitespace-pre-line">
          {selectedEvent.description}
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row justify-center gap-3">
          <button
            onClick={onClose}
            className="bg-gray-300 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-400 transition w-full sm:w-auto"
          >
            Dismiss
          </button>

          <button
            onClick={handleReserveNow}
            className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition w-full sm:w-auto"
          >
            Book Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventPopupModal;